import { render, staticRenderFns } from "./Collaborate.vue?vue&type=template&id=d518ba24&scoped=true"
import script from "./Collaborate.vue?vue&type=script&lang=js"
export * from "./Collaborate.vue?vue&type=script&lang=js"
import style0 from "./Collaborate.vue?vue&type=style&index=0&id=d518ba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518ba24",
  null
  
)

export default component.exports